<template>
  <div class="c-machine">
    <div class="c-machine__banner">
      <div class="c-machine__name"># {{ `${item.serial_number} - ${item.model_name}` }}</div>
      <img class="c-machine__label" src="@/assets/mywah_cooler_front_x1.png"/>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { MACHINE_READ } from '@/store/actions/machine';


export default {
  name: 'Machine',

  props: {
    machineId: Number
  },

  data: () => ({
    loading: false
  }),

  computed: {
    ...mapState({
      item: state => state.machine.machine
    })
  },

  mounted () {
    this.fetchData();
  },

  watch: {
    'wineId': function () {
      this.fetchData();
    }
  },

  methods: {
    fetchData () {
      this.loading = true;

      this.$store.dispatch(MACHINE_READ, this.machineId)
        .catch(e => {
          this.$log.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.c-machine {
  position: relative;

  &__banner {
    position: relative;
    background-color: grey;
    width: 80%;
    left: 10%;
    height: 40px;
    margin-top: 50px;
    margin-bottom: 30px;
    padding-left: 50px;
  }

  &__name {
    font-weight: bold;
    text-transform: capitalize;
  }

  &__label {
    position: absolute;
    width: 80px;
    height: 100px;
    object-fit: cover;
    top: 50%;
    left: 50%;
    margin-top: -50px;
    margin-left: -40px;
  }
}
</style>
